module.exports = {"450403005":"角嘴街道","450403006":"东兴街道","450403007":"富民街道","450403008":"城南街道","450403009":"城北街道","450403101":"城东镇","450403103":"龙湖镇","450403104":"夏郢镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450403.json
// module id = 2237
// module chunks = 0